module.exports = __webpack_public_path__ + "img/whats.34bfdecd.png";